var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons_Location_Arrow_Line",
    "data-name": "icons/Location Arrow/Line",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.532,
    height: 19.532,
    viewBox: "0 0 19.532 19.532",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M16.064.2a2.5,2.5,0,0,1,3.269,3.269L13.409,17.685a3,3,0,0,1-5.728-.661L6.942,12.59l-4.434-.739a3,3,0,0,1-.661-5.728Zm1.423,2.5a.5.5,0,0,0-.654-.654L2.616,7.969a1,1,0,0,0,.22,1.909l4.434.739a2,2,0,0,1,1.644,1.644L9.654,16.7a1,1,0,0,0,1.909.22Z",
    transform: "translate(0 0)",
    fill: "#2148ff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareLink);
export default __webpack_public_path__ + "static/media/shareLink.caeedd3428a14eab2e56c0b863c8eed1.svg";
export { ForwardRef as ReactComponent };